export { default } from "./TableInfoPopover";
